import React from 'react'
import { cn } from '@/lib/utils'

const Main = ({ className, children }) => (
  <div className={cn('main', className)}>{children}</div>
)

export default Main
